/*
 * Arrastrar para desplazar la pagina, en el totem.
 *
 * En el totem no se podia bajar por la pagina con el dedo: solo con la barra.
 * Dos causas, y se atienden las dos:
 *
 *  - theme.scss pone `touch-action: none` en html y body. Es para que no se haga
 *    zoom, pero tambien le prohibe al navegador desplazar con el dedo. Aqui se
 *    deja en `pan-x pan-y`: desplaza y sigue sin zoom.
 *  - Muchas pantallas de kiosko entregan el dedo como RATON. Para el navegador
 *    eso es un clic mantenido, no un gesto, y ningun CSS lo convierte en
 *    desplazamiento. Por eso, con el raton, arrastrar desplaza a mano, con un
 *    poco de inercia al soltar.
 *
 * Solo en el modo totem: en un movil el dedo ya llega como dedo, y en un
 * ordenador arrastrar con el raton tiene que seguir seleccionando texto.
 */
const UMBRAL = 8 // px antes de decidir que es un arrastre y no un toque
const FRENADO = 0.94

export default function arrastreTotem() {
  const raiz = document.documentElement
  raiz.style.touchAction = 'pan-x pan-y'
  document.body.style.touchAction = 'pan-x pan-y'
  document.body.style.userSelect = 'none'

  let gesto = null

  const desplazable = (el) => {
    for (; el && el !== document.body && el !== raiz; el = el.parentElement) {
      const estilo = getComputedStyle(el)
      if (/(auto|scroll)/.test(estilo.overflowY) && el.scrollHeight > el.clientHeight) {
        return el
      }
    }
    return document.scrollingElement || raiz
  }

  const anularClic = (e) => {
    e.stopPropagation()
    e.preventDefault()
  }

  window.addEventListener('pointerdown', (e) => {
    if (e.pointerType !== 'mouse' || e.button !== 0) return
    if (e.target.closest('input, textarea, select, [contenteditable="true"]')) return
    gesto = { x: e.clientX, y: e.clientY, ultimaY: e.clientY, t: e.timeStamp, v: 0, vertical: null, el: desplazable(e.target) }
  })

  window.addEventListener('pointermove', (e) => {
    if (!gesto || !(e.buttons & 1)) return

    if (gesto.vertical === null) {
      const dx = e.clientX - gesto.x
      const dy = e.clientY - gesto.y
      if (Math.hypot(dx, dy) < UMBRAL) return
      // Lo horizontal se deja a los carruseles, que ya saben arrastrarse.
      gesto.vertical = Math.abs(dy) > Math.abs(dx)
    }
    if (!gesto.vertical) return

    const paso = e.clientY - gesto.ultimaY
    gesto.el.scrollTop -= paso
    gesto.v = paso / Math.max(1, e.timeStamp - gesto.t)
    gesto.t = e.timeStamp
    gesto.ultimaY = e.clientY
  })

  const soltar = () => {
    if (!gesto) return
    const { el, v, vertical } = gesto
    gesto = null
    if (!vertical) return

    // El clic que el navegador manda al soltar no es un clic: era un arrastre.
    // Se quita en el siguiente tic por si no llega, que no se coma el de despues.
    window.addEventListener('click', anularClic, { capture: true, once: true })
    setTimeout(() => window.removeEventListener('click', anularClic, { capture: true }), 0)

    let velocidad = v * 16 // px por fotograma
    const inercia = () => {
      if (Math.abs(velocidad) < 0.5) return
      el.scrollTop -= velocidad
      velocidad *= FRENADO
      requestAnimationFrame(inercia)
    }
    requestAnimationFrame(inercia)
  }

  window.addEventListener('pointerup', soltar)
  window.addEventListener('pointercancel', () => (gesto = null))
  // Sin esto, arrastrar sobre una imagen la «coge» en vez de desplazar.
  window.addEventListener('dragstart', (e) => e.preventDefault())
}
